import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ColorBusiness } from '@app/models/color-business';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class ColorBusinessService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get(`${API}colorBusiness`);
  }

  getOne(id) {
    return this.http.get(`${API}colorBusiness/${id}`);
  }

  update(id: any, data: any) {
    return this.http.put(`${API}colorBusiness/${id}`, data);
  }

  delete(id: number) {
    return this.http.put(`${API}colorBusiness/delete/${id}`, { id: id });
  }

  create(colorBusiness: ColorBusiness) {
    return this.http.post(`${API}colorBusiness`, colorBusiness);
  }
}
